import { useQuery } from '@tanstack/react-query';

import { useListagemContext } from 'context/ListagemContext';
import { usePedidoCompraContext } from 'context/PedidoCompraContext';
import { RequestOptionsType, SortProps, useRequestListagem } from 'hooks/useRequestListagem';
import { RequestListagemProdutoPedidos } from 'pages/compra/pedido/types';
import { getCdIdempotency } from 'util/idempotency';

export function useQueryProdutos() {
    const { setProdutosRequest, setCdIdempotency } = usePedidoCompraContext();
    const requestListagem = useRequestListagem();
    const { filter, autoLoad, page } = useListagemContext();
    const promotionFilter = filter.find((item) => item.property === 'fgShowPeOferta');
    const sort: SortProps[] = [{ property: 'dsProduto', direction: 'ASC' }];

    if (promotionFilter) sort.unshift({ property: 'peOferta', direction: 'DESC' });

    const requestOptionsProdutos: RequestOptionsType = {
        sort,
        page,
        nested: false,
        limit: 200,
        url: '/compra/pedidocompra/catalogoproduto/configpedido',
        filter: filter?.length ? filter.filter((item) => !['idTipoEntrega'].includes(item.property)) : [],
    };

    return useQuery<RequestListagemProdutoPedidos>({
        queryKey: ['pedido-produtos', requestOptionsProdutos],
        queryFn: () => requestListagem(requestOptionsProdutos).then((res) => res.data),
        enabled: Boolean(autoLoad && filter.length),
        keepPreviousData: true,
        onSuccess: ({ data }) => {
            setProdutosRequest(data);

            setCdIdempotency(getCdIdempotency());
        },
    });
}
